// extracted by mini-css-extract-plugin
export default {"LdsEllipsis":"styles_LdsEllipsis__CuPNw","LdsEllipsis1":"styles_LdsEllipsis1__1-SHb","LdsEllipsis2":"styles_LdsEllipsis2__ivgdl","LdsEllipsis3":"styles_LdsEllipsis3__9u77T"};